"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "weeky-alloc-table-wrapper" };
const _hoisted_2 = { class: "table text-center role-table day-table weeky-alloc-table" };
const _hoisted_3 = { class: "tr-day-numbers" };
const _hoisted_4 = ["onUpdate:modelValue"];
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleRequiredWeekly',
    setup(__props) {
        const role = (0, vue_3.inject)("roleView");
        const dayNumComputed = (0, vue_3.computed)(() => {
            return role?.value.requiredWeekdayNumbers ?? [0, 0, 0, 0, 0, 0, 0, ""];
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("table", _hoisted_2, [
                    _cache[0] || (_cache[0] = (0, vue_2.createElementVNode)("thead", null, [
                        (0, vue_2.createElementVNode)("tr", null, [
                            (0, vue_2.createElementVNode)("th", { class: "th-holiday" }, "日"),
                            (0, vue_2.createElementVNode)("th", null, "月"),
                            (0, vue_2.createElementVNode)("th", null, "火"),
                            (0, vue_2.createElementVNode)("th", null, "水"),
                            (0, vue_2.createElementVNode)("th", null, "木"),
                            (0, vue_2.createElementVNode)("th", null, "金"),
                            (0, vue_2.createElementVNode)("th", { class: "th-saturday" }, "土"),
                            (0, vue_2.createElementVNode)("th", { class: "th-holiday" }, "祝")
                        ])
                    ], -1 /* CACHED */)),
                    (0, vue_2.createElementVNode)("tbody", null, [
                        (0, vue_2.createElementVNode)("tr", _hoisted_3, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(dayNumComputed.value, (_, weekdayNum) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", null, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        class: "form-input text-center b-none",
                                        size: "3",
                                        type: "number",
                                        min: "0",
                                        "onUpdate:modelValue": ($event) => ((dayNumComputed.value[weekdayNum]) = $event)
                                    }, null, 8 /* PROPS */, _hoisted_4), [
                                        [vue_2.vModelText, dayNumComputed.value[weekdayNum]]
                                    ])
                                ]));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                    ])
                ])
            ]));
        };
    }
});
